import React, { FC } from "react"

import { Form, Input, Modal } from "antd"

import { useActions } from "../../../hooks/useActions"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { showFormErrors, showSuccessNotification } from "../../../utils/ui"

interface Props {
    open: boolean
    setOpen: (value: boolean) => void
}

const AddModal: FC<Props> = ({ open, setOpen }) => {

    const [ form ] = Form.useForm()

    const { isLoading } = useTypedSelector((state) => state.access)
    const { accessCreate, accessFetchData } = useActions()
    const addAccess = (values: any) => {
        accessCreate(values, () => {
            setOpen(false)
            showSuccessNotification("Досутп добавлен")
            accessFetchData()
        }, (errors) => {
            showFormErrors(form, errors)
        })
    }

    return (
        <Modal
            title="Добавление доступа"
            open={open}
            onOk={() => form.submit()}
            onCancel={() => setOpen(false)}
            okText="Добавить"
            cancelText="Отмена"
            okButtonProps={{ loading: isLoading }}
            destroyOnClose
        >
            <Form
                className="un-form__wrapper"
                form={form}
                onFinish={addAccess}
                layout="vertical"
                requiredMark={false}
            >

                <Form.Item
                    label="IP"
                    name="address"
                    rules={[ { required: true, message: "Поле обязательное" } ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Описание"
                    name="description"
                    rules={[ { required: true, message: "Поле обязательное" } ]}
                >
                    <Input />
                </Form.Item>

            </Form>
        </Modal>
    )
}

export default AddModal
